import { useEffect, useRef } from "react";
import { redactUrl } from "./scrub";
import { setTelemetryRoute, trackEvent } from "./telemetry";

const SCOPE_PATTERN = /^\/b\/([^/]+)(?:\/l\/([^/]+))?/;

/** Reports each route view as a template (IDs replaced with `:id`) and keeps the business scope on the user. */
export function useRouteTelemetry(pathname: string, action: string) {
  const previous = useRef<{ pathname: string; route: string }>(undefined);
  useEffect(() => {
    if (previous.current?.pathname === pathname) return;
    const route = redactUrl(pathname) || "/";
    const scope = SCOPE_PATTERN.exec(pathname);
    setTelemetryRoute(route, { businessId: scope?.[1], locationId: scope?.[2] });
    trackEvent("navigation.route_viewed", { route, action: action.toLowerCase(), previousRoute: previous.current?.route });
    previous.current = { pathname, route };
  }, [pathname, action]);
}
